import styled from 'styled-components';

export const IncludeRecipientLabel = styled.label`
  margin: 1.5rem 0 0;
`;
